import React from 'react'
import { MonitorWindow } from '../../../blocks.simple/monitorWindow/MonitorWindow'

export const LogService = ({ data, isMobile }: any) => {
    if (!data) return null

    return <MonitorWindow data={data} isMobile={isMobile} />
}
